import Members from "./pages/Members";
import MemberDetail from "./pages/MemberDetail";

const memberRoutes = [
  {
    path: "members",
    element: <Members />,
  },
  {
    path: "members/:id",
    element: <MemberDetail />,
  },
];

export default memberRoutes;
